export const SIMILARITY_FEEDBACK_NEGATIVE = 'negative'
export const SIMILARITY_FEEDBACK_POSITIVE = 'positive'
export type SIMILARITY_FEEDBACK = 'negative' | 'positive'
